import { css, html, LitElement } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import nls from '../../locales/index.nls';

export default
@i18n(nls)
class KiStationDownloadBar extends LitElement {
  // language=CSS
  static styles = css`
    :host {
      display: block;
      background: #4a4a49;
      color: #ffffff;
      border-radius: 30px;
      padding: 10px;
      font-size: 14px;
      line-height: 18px;
    }
    span {
      padding-right: 10px;
    }
    :host(.hide) {
      display: none !important;
    }
    ki-icon {
      cursor: pointer;
      width: 24px;
      height: 24px;
      font-size: 14px;
      text-align: center;
      padding: 5px;
      display: inline-block;
    }

    .disabled{
      color: #aaa;
      cursor: not-allowed;
      display: none;
    }

    ki-icon:hover {
      background: white;
      color: #4a4a49;
      border-radius: 20px;
    }
  `;

  constructor() {
    super();
    this.stations = [];
  }

  static get properties() {
    return {
      stations: { type: Array },
    };
  }

  render() {
    this.classList.toggle('hide', !this.stations.length);
    // language=html
    const plural = this.stations.length===1 ? "" : "s"
    return html`
      <div>
        <span>${this.stations.length} station${plural} sélectionnée${plural}, le téléchargement max est de ${this.downloadLimit}</span>
        <ki-icon class="${this.stations.length > this.downloadLimit ? 'disabled': ''}" icon="ki ki-arrow-alt-to-bottom" @click="${this.download}"></ki-icon>
        <ki-icon icon="ki ki-times" @click="${this.clear}"></ki-icon>
      </div>
    `;
  }

  download() {
    if(this.stations.length> this.downloadLimit){
      return;
    }
    this.dispatchEvent(new CustomEvent('download-station-data'));
  }

  clear() {
    // TODO
    this.dispatchEvent(new CustomEvent('clear'));
  }
}

customElements.define('ki-station-download-bar', KiStationDownloadBar);
